import React, { useEffect, useState } from 'react';
import COTable from 'shared/components/COTable';
import SupplierService from 'services/ValueChainService/supplier.service';
import CreateSupplierModal from 'shared/components/CreateSupplierModal';
import { SupplierTableProps } from 'enums/SupplierEnums';
import { getColumns } from './SupplierColumns';
import EditValueChainModal from 'shared/components/EditModal';
import style from './Suppliers.module.scss';
import { Supplier } from 'models/Supplier/Supplier.model';
import COButton from 'shared/components/COButton';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import { ButtonProps, SearchProps, TabsKeys } from 'enums/ValueChainListEnums';
import { useLocation } from 'react-router-dom';
import COPagination from 'shared/components/COPagination';
import COSearch from 'shared/components/COSearch';
import { searchUtil } from 'shared/utils/SearchUtil';

const SuppliersList: React.FC = () => {
  const location = useLocation();
  const [SupplierModalState, setSupplierModalState] = useState<boolean>(false);
  const [clickedRow, setClickedRow] = React.useState<number | null>(null);
  const [searchValue, setSearchValue] = useState<string>('');
  const [clickedRowData, setClickedRowData] = React.useState<Supplier>();
  const {
    createSupplier,
    updateSupplier,
    fetchSuppliers,
    supplierList,
    deleteSupplier,
    loading,
    currentPage,
    totalItems,
    buttonLoading,
  } = SupplierService();

  const user = localStorage.getItem('userDetails');
  let parsedUser;
  if (user !== null) {
    parsedUser = JSON.parse(user);
  }
  const [showEditModalState, setEditModalState] =
    React.useState<boolean>(false);
  const [showDeleteModalState, setDeleteModalState] =
    React.useState<boolean>(false);

  /** Handle Open/close states for edit modal */
  const handleOpenEditModal = () => {
    setEditModalState(true);
  };

  const handleCloseEditModal = () => {
    setEditModalState(false);
  };

  /** Handle Open/close states for edit modal */
  const handleOpenDeleteModal = () => {
    setDeleteModalState(true);
  };

  /** Handle Confirm button API call inside the modal */
  const handleDeleteModalState = (value: boolean) => {
    if (clickedRow !== null) {
      deleteSupplier(clickedRow);
    }
    setDeleteModalState(value);
  };

  const handleCancelDelete = () => setDeleteModalState(false);
  const handleEditModalState = (value: boolean) => {
    setEditModalState(value);
  };

  const handleRowClick = (record: Supplier) => {
    record?.id && setClickedRow(record.id);
    setClickedRowData(record);
  };

  useEffect(() => {
    fetchSuppliers({ size: 20 });
  }, []);

  const columns = getColumns({
    handleOpenEditModal,
    handleOpenDeleteModal,
  });
  const handleSupplierModalCancel = () => {
    setSupplierModalState(false);
  };
  const handleSupplierModalConfirm = () => {
    setSupplierModalState(false);
  };
  const handleOpenSupplierModal = () => {
    setSupplierModalState(true);
  };
  const isActiveTab = (key: string) => {
    let currentPage = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentPage] === key;
  };
  const handlePaginationChange = (page: number, pageSize: number) => {
    fetchSuppliers({ page: page, size: pageSize });
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    const searchValue = e.target.value;
    searchUtil((searchVal: string) => {
      fetchSuppliers({ name: searchVal, size: 20 });
    })(searchValue);
  };

  return (
    <div>
      <div className={style.searchContainer}>
        <COSearch
          name={SearchProps.SEARCH_NAME}
          placeholderString={SearchProps.PLACEHOLDER_STRING}
          inputValue={searchValue}
          handleChange={handleInputChange}
        />
      </div>
      <div className={style.paginationContainer}>
        <COPagination
          onChange={handlePaginationChange}
          total={totalItems}
          current={currentPage}
        />
      </div>
      <CreateSupplierModal
        showModalState={SupplierModalState}
        handleModalCancel={handleSupplierModalCancel}
        handleModalConfirm={handleSupplierModalConfirm}
        createSupplier={createSupplier}
        updateSupplier={updateSupplier}
        id={parsedUser.id}
        loading={buttonLoading || loading}
      />
      {isActiveTab(TabsKeys.SUPPLIERS) && (
        <div className={style.createButtonContainer}>
          <COButton onClick={handleOpenSupplierModal}>
            <Add /> {ButtonProps.NEW_SUPPLIER}
          </COButton>
        </div>
      )}
      <COTable
        columns={columns}
        loading={loading || buttonLoading}
        showEditModalState={showEditModalState}
        showDeleteModalState={showDeleteModalState}
        handleDeleteModalStateConfirm={handleDeleteModalState}
        handleDeleteModalStateCancel={handleCancelDelete}
        handleEditModalStateConfirm={handleEditModalState}
        handleEditModalStateCancel={handleEditModalState}
        handleRowClick={handleRowClick}
        headingDelete={SupplierTableProps.DELETE_HEADING}
        subheadingDelete={SupplierTableProps.DELETE_SUBHEADING}
        data={supplierList}
        editModal={
          <EditValueChainModal
            showModalState={showEditModalState}
            handleModalCancel={handleCloseEditModal}
            handleModalConfirm={handleCloseEditModal}
            preFetchedData={clickedRowData}
            supplier
            updateSupplier={updateSupplier}
            buttonLoading={buttonLoading || loading}
          />
        }
      />
    </div>
  );
};

export default SuppliersList;
